/**
 * Verified Google reviews used as trust signals at conversion points (LIND-30).
 *
 * `quote` is the full review, reproduced verbatim from `reviewUrl` — do not tidy
 * wording, spelling or punctuation, since a visitor can check it against the
 * original. `highlight` is the phrase the design picks out in blue and must be an
 * exact substring of `quote`; it can sit anywhere in it, not just at the end. If
 * the two ever drift apart the quote simply renders without emphasis.
 */
export interface ITestimonial {
	quote: string;
	highlight: string;
	author: string;
	reviewUrl: string;
}

export const TESTIMONIALS: ITestimonial[] = [
	{
		quote: 'Great distribution and warehousing facilities. Clean, knowledgeable employees and a great location. What more can you ask for.',
		highlight: 'What more can you ask for.',
		author: 'Lane McConnell',
		reviewUrl: 'https://maps.app.goo.gl/PLFLhs4DsZTntMfa6',
	},
	{
		quote: 'Lindner Logistics is a first-class operation. They run a great company built on integrity, professionalism, and follow-through. In an industry where reputation matters, they consistently do what they say they’re going to do. It’s always a pleasure doing business with a team you can trust.',
		highlight: 'It’s always a pleasure doing business with a team you can trust.',
		author: 'Nick Crawley',
		reviewUrl: 'https://maps.app.goo.gl/TAkDHSCH9cPEuvdo6',
	},
	{
		quote: 'In the world of shipping and receiving, Lindner is the example to be beat. Not a lot of parking, but give it ten or fifteen minutes and you will get a door. Trucks were in and out in thirty minutes. Very professional and friendly personnel. Can’t say enough about this place.',
		highlight: 'Very professional and friendly personnel.',
		author: 'George',
		reviewUrl: 'https://maps.app.goo.gl/nbswe81TLZjb33u2A',
	},
	{
		quote: 'Top notch warehousing services, they’ve made significant investments in facilities and technology.',
		highlight: 'they’ve made significant investments in facilities and technology.',
		author: 'Brandon Ciebell',
		reviewUrl: 'https://maps.app.goo.gl/fSaZ8m7qBCFw2pAD8',
	},
];
